import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Component from 'decorators/Component'
import breakpoint from 'tools/styled-components-breakpoint'
import { getTranslatedWeekDays } from 'tools/date'

const WeekDayContainer = styled.div`
  display: table-cell;
`

const WeekDayContent = styled.div`
  font-size: 13px;
  width: 2.5em;
  height: 2.5em;
  ${breakpoint('desktop')`
    width: 3.5em;
    height: 3.5em;
  `}
  padding: 0.25em;
  color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
`

const WeekDay = Component()(({ t, weekday }) => (
  <WeekDayContainer>
    <WeekDayContent>
      {getTranslatedWeekDays(t)[weekday]}
    </WeekDayContent>
  </WeekDayContainer>
))
WeekDay.propTypes = {
  weekday: PropTypes.number.isRequired, // injected by react-day-picker
  t: PropTypes.string.isRequired // injected by Component
}

export default WeekDay
